import SrtDownloadPlaceholder from '@/shared/assets/images/srt-download.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';
import { getBullets } from './bullets';
import { BULLETS_HEADER_TEXT, BUTTON_TEXTS } from './texts';

const BASE_CONTENT: ModalContent = {
  title: 'Unlock .SRT download',
  bulletsHeader: BULLETS_HEADER_TEXT.withCreatorPro,
  buttonText: BUTTON_TEXTS.toCreatorPro,
  features: getBullets([
    'translate100',
    'lipSync',
    'srtUploadDownload',
    'voiceCloneSettings',
    'voicePresets',
    'subtitles',
    'aiRewrite',
  ]),
  media: {
    src: SrtDownloadPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: MixpanelEvents.upgradeSrtDownloadModalClick,
  mixpanelOpeningEvent: MixpanelEvents.upgradeSrtDownloadModalShown,
  subtitle:
    'Upgrade to Creator Pro plan to download SRT files containing subtitles for both the original and translated videos',
};

const TRIAL_PLAN_CONTENT = {
  ...BASE_CONTENT,
};

const STARTER_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inTrial,
};

const CREATOR_PLAN_CONTENT = {
  ...BASE_CONTENT,
  bulletsHeader: BULLETS_HEADER_TEXT.inCreator,
};

export const SRT_DOWNLOAD_CONTENT: LimitedFeatureContent = {
  creator: CREATOR_PLAN_CONTENT,
  starter: STARTER_PLAN_CONTENT,
  trial: TRIAL_PLAN_CONTENT,
};
